import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-disqualified",
  "use": "icon-disqualified-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 13 13\" id=\"icon-disqualified\">\n    <path fill=\"currentColor\" d=\"M1.083 0C.491 0 0 .491 0 1.083v9.75c0 .592.491 1.083 1.083 1.083h2.108c.015.003.027.01.042.012l7.042 1.06c.597.09 1.156-.323 1.246-.92l1.467-9.75c.09-.598-.323-1.156-.92-1.246L9.101.625C8.927.26 8.554 0 8.125 0H1.083zm0 1.083h7.042v9.75H1.083v-9.75z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol